import { cx } from '../lib/cx';
import styles from './Pill.module.css';

type PillProps = {
  children: string;
  small?: boolean;
};

export function Pill({ children, small }: PillProps) {
  return <li className={cx(styles.pill, small && styles.small)}>{children}</li>;
}

type PillsProps = {
  items: readonly string[];
  small?: boolean;
  className?: string;
  'aria-label'?: string;
};

/** A wrapping row of outlined mono tags. */
export function Pills({ items, small, className, ...rest }: PillsProps) {
  return (
    <ul className={cx(styles.list, small && styles.listSmall, className)} {...rest}>
      {items.map((item) => (
        <Pill key={item} small={small}>
          {item}
        </Pill>
      ))}
    </ul>
  );
}
